"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyBar = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const MinWidth_1 = require("./MinWidth");
const useStyles = makeStyles_1.default(() => ({
    root: {
        position: "fixed",
    },
}));
exports.StickyBar = ({ side, center, minWidth, children, ...props }) => {
    const theme = useTheme_1.default();
    const classes = useStyles();
    const top = props.top !== undefined ? props.top : theme.spacing(10);
    const width = react_1.useMemo(() => `calc((100vw - ${theme.breakpoints.values[center]}px) / 2)`, [theme, center]);
    const maxHeight = react_1.useMemo(() => `calc(100vh - ${top}px)`, [top]);
    const style = {
        top,
        width,
        maxHeight,
        ...props.style,
    };
    side === "right" ? (style.right = 0) : (style.left = 0);
    return (react_1.default.createElement(MinWidth_1.MinWidth, { width: minWidth, className: classes.root, style: style }, children));
};
exports.StickyBar.propTypes = {
    side: prop_types_1.default.oneOf(["right", "left"]).isRequired,
    top: prop_types_1.default.number,
    center: prop_types_1.default.oneOf(["xs", "sm", "md", "lg", "xl"]).isRequired,
    minWidth: prop_types_1.default.number.isRequired,
    style: prop_types_1.default.any,
    children: prop_types_1.default.node.isRequired,
};
//# sourceMappingURL=StickyBar.js.map